import { FC } from 'react';
import { CarDetail } from './CarDetail/CarDetail';

export const CarDetailPage: FC = () => {
  return <CarDetail />;
};
